module.exports = __webpack_public_path__ + "static/media/masks.ce47b62a.png";